import { render, staticRenderFns } from "./AgeGroupSidebar.vue?vue&type=template&id=7378d3ee&scoped=true&"
import script from "./AgeGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./AgeGroupSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AgeGroupSidebar.vue?vue&type=style&index=0&id=7378d3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378d3ee",
  null
  
)

export default component.exports